import moment from "moment";
import {
  Text,
  Group,
  Badge,
  Card,
  Loader,
  Tabs,
  Button,
  Menu,
  ActionIcon,
  NumberInput,
} from "@mantine/core";
import DataTable from "./dataTable";

import { IconDotsVertical, IconRefresh } from "@tabler/icons";
import { showNotification } from "@mantine/notifications";
import { getYearColumnDefs } from "../helpers/commissionScheduleYears";
import { useTabNavigate } from "../hooks/useTabNavigate";

const CommissionSettingScheduleCard = ({
  commissionSetting,
  rateFactor = 1,
  mode = "view",
  isCertain = false,
  onRefresh = () => {},
  onReset = () => {},
  onCustomize = () => {},
}) => {
  const tabNav = useTabNavigate();
  const { row, productSchedule } = commissionSetting ?? {};
  const { grossRate, conditions, isCustomized } = row ?? {};
  const commissionSchedule = productSchedule?.commissionSchedule;

  const openCommissionSchedule = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!commissionSchedule?._id) return;
    tabNav.openDetail({
      pathname: "/management/commissionSchedule",
      id: commissionSchedule._id,
      mode: "edit",
      label: commissionSchedule.code,
    });
  };

  const getRate = (rate) => {
    return (rate * 100 * rateFactor).toFixed(2);
  };
  const data = [
    {
      grossRate: grossRate,
    },
  ];
  const columns = getYearColumnDefs().map(({ key, label }) => ({
    field: `grossRate.${key}`,
    headerName: label,
    cellRender: (col, data) => {
      return mode == "edit" ? (
        <NumberInput
          size="xs"
          value={+getRate(data.grossRate?.[key])}
          suffix="%"
          precision={2}
          onChange={(value) => {
            data.grossRate[key] = value / (100 * rateFactor);
          }}
        />
      ) : (
        <Text
          size="xs"
          color={key === "yr1" && !data.grossRate?.[key] ? "red" : "inherit"}
        >
          {getRate(data.grossRate?.[key] ?? 0)}%
        </Text>
      );
    },
  }));

  return (
    <>
      {/* {isCustomized ? "Customize" : "default"} */}
      {/* <ReactJson
        name="commissionSetting"
        src={commissionSetting}
        style={{ backgroundColor: "white" }}
      /> */}
      <Group position="apart" mt="md" mb="md">
        <Group spacing={2}>
          <Badge size="xs" color={isCertain ? "green" : "red"} radius="xs">
            {isCertain ? "Certain" : "UnCertain"}
          </Badge>
          {!isCustomized && commissionSchedule?.code && (
            <Badge
              size="xs"
              color="violet"
              radius="xs"
              sx={{ cursor: "pointer" }}
              onClick={openCommissionSchedule}
            >
              {commissionSchedule.code}
            </Badge>
          )}
          {!isCustomized && productSchedule?.code && (
            <Badge size="xs" color="blue" radius="xs">
              {productSchedule.code}
            </Badge>
          )}
          {!isCustomized && !productSchedule && (
            <Badge size="xs" color="red" radius="xs">
              No Product Schedule found
            </Badge>
          )}

          {!isCustomized && (
            <Group spacing={2}>
              {conditions?.map((condition) => (
                <Badge size="xs" color="blue" radius="xs">
                  {condition}
                </Badge>
              ))}
            </Group>
          )}
          {!isCustomized && !row && (
            <Group spacing={2}>
              <Badge size="xs" color="red" radius="xs">
                No Commission Row matched
              </Badge>
            </Group>
          )}

          {isCustomized && (
            <Badge size="xs" color="red" radius="xs">
              Customized
            </Badge>
          )}
        </Group>

        <Group>
          <ActionIcon onClick={onRefresh} size="xs">
            <IconRefresh size={16} aria-label="Refresh" />
          </ActionIcon>
          <Menu position="bottom-end" withinPortal size="xs">
            <Menu.Target>
              <ActionIcon>
                <IconDotsVertical size={16} />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item onClick={onReset} py={5}>
                <Text size="xs">Reset Schedule</Text>
              </Menu.Item>
              <Menu.Item onClick={onCustomize} py={5}>
                <Text size="xs">Customize Schedule</Text>
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>
      </Group>

      {commissionSetting && (
        <Card withBorder mb="md">
          <DataTable
            columns={columns}
            data={data}
            hidePagination={true}
            hideSearchBar={true}
            padding="xs"
            tdPaddingX={"2px"}
          />
          <Group mt={0} spacing={"xl"}>
            <Text size="xs" mt="xs" color="dimmed">
              {productSchedule?.effectiveDate &&
                `Effective: ${moment(productSchedule?.effectiveDate).format(
                  "YYYY-MM-DD"
                )}`}
            </Text>
            <Text size="xs" mt="xs" color="dimmed">
              {productSchedule?.endDate &&
                ` Expired: ${moment(productSchedule?.endDate).format(
                  "YYYY-MM-DD"
                )}`}
            </Text>
          </Group>
        </Card>
      )}
      {!productSchedule && (
        <Card withBorder mb="md">
          <Text size="xs" color="dimmed">
            No Commission Schedule found
          </Text>
        </Card>
      )}
    </>
  );
};

export default CommissionSettingScheduleCard;
